const stateRoot = (state) => state.programs;

export const getIsLoadingPrograms = (state) => stateRoot(state).isLoading;

export const getCurrentTab = (state) => stateRoot(state).currentTab;
